import { useEffect, useState } from "react";
import { PoolName, User } from "../../../../jobApprovalFlow/types";
import DefaultModal from "../component/dialog";
import InputField from "../../../../../components/InputFieldForm";
import { useApprovalFlowController } from "../../../../jobApprovalFlow/controllers/useApprovalFlowController";
import SelectdDropDown from "../../../../../components/DropDownComponent";
import { useApprovalViewModel } from "../viewmodel/approvalViewModel";
import {
  hideToast,
  setShowModal,
  updateFormField,
} from "../viewmodel/appprovalPool.action";
import { PoolModelData, CreatePool } from "../model/approvalPoolModel";
import { Console } from "console";
import MultiSelectDropdown from "../../../../../components/MultiSelectDropDown";
import Toast from "../../../../../components/Toast";

interface CreatePoolDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  existingPool: PoolModelData;
  onSave?: (pool: Omit<PoolName, "id" | "createdAt">) => void;
  approvalVM: ReturnType<typeof useApprovalViewModel>;
  mode: "create" | "edit" | "view";
}

export const CreatePoolDialog = ({
  onSave,
  approvalVM,
  open,
  onOpenChange,
  existingPool,
  mode,
}: CreatePoolDialogProps) => {
  const { state, dispatch, handleCreatePool } = approvalVM;
  const handleUpdateFormField = (field: keyof CreatePool, value: any) =>
    dispatch(updateFormField(field, value));
  useEffect(() => {
    if (existingPool && (mode === "edit" || mode === "view")) {
      dispatch(updateFormField("name", existingPool.name));
      dispatch(updateFormField("description", existingPool.description));
      dispatch(
        updateFormField(
          "members",
          existingPool.members?.map((m: any) => m.company_user_id) || [],
        ),
      );
    }
  }, [existingPool, mode]);
  // useEffect(() => {
  //   if (existingPool) {
  //     dispatch(updateFormField("name", existingPool.name));
  //     dispatch(updateFormField("description", existingPool.description));
  //     dispatch(
  //       updateFormField(
  //         "members",
  //         existingPool.members?.map((m: any) => m.company_user_id) || [],
  //       ),
  //     );
  //     // dispatch(updateFormField("member_ids", existingPool.member_count));
  //   } else {
  //     dispatch({ type: "RESET_POOL_FORM", payload: "" });
  //   }
  // }, [existingPool]);

  return (
    <>
      <DefaultModal
        className="w-full max-w-full sm:max-w-xl lg:max-w-2xl mx-2 sm:mx-auto"
        open={open}
        onClose={() => {
          onOpenChange(false);
        }}
      >
        <div className="flex flex-col max-h-[90vh] sm:max-h-[85vh]">
          <div className="p-4 sm:p-6">
            <h2 className="text-lg font-semibold">
              {mode === "view"
                ? "View Pool"
                : existingPool
                ? "Edit Pool"
                : "Create Pool"}
            </h2>

            <p className="text-gray-600 text-sm mb-4">
              Create a pool of users for approval workflows
            </p>
          </div>

          <div className="flex-1 overflow-y-auto p-4 sm:p-6 space-y-4">
            <InputField
              id="name"
              label="Pool Name"
              placeholder="e.g., Engineering, HR, Frontend Dev"
              value={state.poolFormData.name}
              onChange={(e) => handleUpdateFormField("name", e.target.value)}
              required
              disabled={mode === "view"}
            />
            <InputField
              id="description"
              label="Description"
              placeholder="description"
              value={state.poolFormData.description}
              onChange={(e) =>
                handleUpdateFormField("description", e.target.value)
              }
              required
              disabled={mode === "view"}
            />

            <div className="flex-1 overflow-visible p-2 space-y-4">
              <MultiSelectDropdown
                disabled={mode === "view"}
                label="Users"
                options={state.users.map((u) => ({
                  label: u.full_name,
                  value: u.id,
                }))}
                value={state.poolFormData.members ?? []}
                onChange={(values) =>
                  dispatch(updateFormField("members", values))
                }
              />
            </div>
          </div>
          <div className="sticky bottom-0 bg-white p-4 border-t flex flex-col sm:flex-row gap-3 sm:justify-end">
            <button
              className="w-full sm:w-auto bg-gray-500 text-white px-4 py-2 rounded-md"
              onClick={() => onOpenChange(false)}
            >
              {mode === "view" ? "Close" : "Cancel"}
            </button>

            {mode !== "view" && (
              <button
                className={`w-full sm:w-auto px-4 py-2 rounded-md text-white ${
                  !state.poolFormData.name || !state.poolFormData.description
                    ? "bg-indigo-300 cursor-not-allowed"
                    : "bg-indigo-600 hover:bg-indigo-700"
                }`}
                onClick={handleCreatePool}
                disabled={
                  !state.poolFormData.name || !state.poolFormData.description
                }
              >
                {state.loading
                  ? mode === "edit"
                    ? "Updating..."
                    : "Creating..."
                  : mode === "edit"
                  ? "Update Pool"
                  : "Create Pool"}
              </button>
            )}
          </div>
         
        </div>
      </DefaultModal>
      <Toast
        message={state.toast.message}
        type={state.toast.type}
        isVisible={state.toast.isVisible}
        onClose={hideToast}
      />
    </>
  );
};
